<template>
  <FormRulesProvider :module-name="$constants.TASK">
    <FlotoModule>
      <template v-if="hasTaskAccess">
        <RouterView :key="$route.fullPath" />
      </template>
    </FlotoModule>
  </FormRulesProvider>
</template>

<script>
import { PageMethods } from '@state/modules/page'
import { isLoggedIn, isCxoUser } from '@utils/auth'
import { LicenseComputed } from '@state/modules/license'
import { PreferenceComputed } from '@state/modules/preference'
import { CustomRulesMethods } from '@state/modules/custom-rules'
import { taskPermissionsMixin } from '@src/mixins/task-permissions'
import FormRulesProvider from '@components/providers/form-rules-provider/form-rules-provider'

export default {
  name: 'MyTasksModule',
  page() {
    return {
      title: this.$tc('my_tasks'),
    }
  },
  components: { FormRulesProvider },
  mixins: [taskPermissionsMixin],

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.availableModulesInLicense.indexOf(vm.$constants.TASK) === -1) {
        return vm.$router.replace({ name: 'upgrade-plan' })
      }

      if (isLoggedIn() && isCxoUser()) {
        return vm.$router.replace({ name: '404' })
      }

      if (!vm.hasProjectRequesterLicense && !vm.hasAnyModuleTaskAccess) {
        return vm.$router.replace({ name: '404' })
      }

      vm.hasTaskAccess = true

      if (
        vm.availableModulesInLicense.indexOf(vm.$constants.PROJECT) >= 0 &&
        vm.myAllowedModules.indexOf(vm.$constants.PROJECT) >= 0
      ) {
        if (vm.projectFetchWorklogRules) {
          vm.projectFetchWorklogRules()
        }
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    // add any module level clean up logic here
    setTimeout(() => {
      if (this.taskPageReset) {
        this.taskPageReset()
      }
    }, 400)
    next()
  },

  data() {
    return {
      hasTaskAccess: false,
    }
  },

  computed: {
    ...LicenseComputed,
    ...PreferenceComputed,

    hasAnyModuleTaskAccess() {
      const modules = [
        this.$constants.REQUEST,
        this.$constants.PROBLEM,
        this.$constants.CHANGE,
        this.$constants.RELEASE,
        this.$constants.PROJECT,
        this.$constants.TASK,
      ]

      return modules.some(
        (module) =>
          this.myAllowedModules.indexOf(
            this.getTaskPermissionString(module, 'view')
          ) !== -1
      )
    },
  },
  methods: {
    ...PageMethods,
    ...CustomRulesMethods,
  },
}
</script>
